/* eslint-disable react/prop-types */
/* eslint-disable camelcase */
import React, { useState } from 'react';

import { Link } from '~/techstyle-shared/next-routes';

import { CARD_WIDTH } from '../../constants';
import useBuilderConstructorGridInputs from '../../hooks/useBuilderConstructorGridInputs';
import {
  getActiveProduct,
  getSwatchesWithPdpLink,
} from '../../utils/activeProduct';

import ProductCardCallout from './ProductCardCallout';
import ProductCardFavoriteButton from './ProductCardFavoriteButton';
import ProductCardImage from './ProductCardImage';
import ProductCardPricing from './ProductCardPricing';
import ProductCardPromoMessage from './ProductCardPromoMessage';
import ProductCardSwatches from './ProductCardSwatches';

const ProductCard = ({
  id,
  label,
  permalink,
  image_service_url,
  item_number,
  pricing,
  relatedProductsData,
  sku,
  facets,
  tag_id_list = [],
  membership_brand_id,
}) => {
  const [activeProductId, setActiveProductId] = useState(Number(id));
  const { productSource } = useBuilderConstructorGridInputs();

  // TODO: add platinum exclusive lock UI
  // Reference `ProductCell.js` for feature set

  // TODO: filter out related swatches/products by membership.
  // ideally pass membership status to the related products api
  // reference: requiredUserStatus in GridSwatches.js

  const cioProductData = {
    id,
    label,
    permalink,
    image_service_url,
    item_number,
    pricing,
    sku,
    facets,
    tag_id_list,
    membership_brand_id,
  };

  const activeProduct = getActiveProduct({
    relatedProducts: relatedProductsData?.relatedProducts,
    swatches: relatedProductsData?.swatches,
    cioProductData,
    productSource,
    activeProductId,
  });

  const swatchesWithPdpLink = getSwatchesWithPdpLink({
    swatches: relatedProductsData?.swatches,
    productSource,
    cioProductData,
    relatedProducts: relatedProductsData?.relatedProducts,
  });

  return (
    <div className={`max-w-[${CARD_WIDTH}px] relative`}>
      <ProductCardFavoriteButton product={activeProduct} />
      <Link href={activeProduct?.pdpLink}>
        <a>
          <ProductCardImage
            imageServiceUrl={activeProduct?.imageServiceUrl}
            swatchLabel={activeProduct?.swatchLabel}
            images={activeProduct?.images}
            sku={activeProduct?.sku}
            isPrimaryProduct={Number(activeProduct?.id) === Number(id)}
          />
        </a>
      </Link>
      <ProductCardSwatches
        swatches={swatchesWithPdpLink}
        activeProductId={activeProductId}
        setActiveProductId={setActiveProductId}
        activeProductPdpLink={activeProduct?.pdpLink}
      />
      <Link href={activeProduct?.pdpLink}>
        <a>
          <p>{activeProduct?.label}</p>
          <ProductCardPromoMessage />
          <ProductCardPricing {...activeProduct?.pricing} />
          <ProductCardCallout product={activeProduct} />
        </a>
      </Link>
    </div>
  );
};

export default ProductCard;
